<script lang="ts">
  import type { Snippet } from 'svelte';
  let { label, hint, control, extra }: { label: string; hint: Snippet; control: Snippet; extra?: Snippet } = $props();
</script>

<div class="frow">
  <div>
    <div class="lab">{label}</div>
    <div class="hint">{@render hint()}</div>
    {#if extra}{@render extra()}{/if}
  </div>
  <div class="ctl">{@render control()}</div>
</div>

<style>
  .frow { display: flex; align-items: flex-start; justify-content: space-between; gap: 20px; padding: 7px 0; }
  .lab { font-size: 13px; font-weight: 500; }
  .hint { margin-top: 2px; font-size: 11.5px; color: var(--text-dim); line-height: 1.5; max-width: 560px; }
  .ctl { flex-shrink: 0; display: flex; align-items: center; gap: 8px; }
  @media (max-width: 560px) { .frow { flex-direction: column; } }
</style>
